document.addEventListener("DOMContentLoaded", () => {

    const popup = document.querySelector("#size-reminder-popup dialog");

    if (!popup) return;

    const confirmCheckbox = document.querySelector("#size-confirm-checkbox");
    const continueButton = document.querySelector("#size-reminder-add");
    const disableReminder = document.querySelector("#size-reminder-disable");

    let originalButton = null;
    let bypassReminder = false;

    // Intercept Add to Cart
    document.addEventListener(
        "click",
        function (e) {

            const btn = e.target.closest("[data-original-add-cart]");

            if (!btn) return;

            // Skip popup when Continue button triggers original click
            if (bypassReminder) {
                bypassReminder = false;
                return;
            }

            // Don't show popup if user disabled it
            if (localStorage.getItem("disable-size-reminder") === "true") {
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();

            originalButton = btn;

            popup.showModal();
        },
        true
    );

    // Enable Continue button
    confirmCheckbox.addEventListener("change", function () {

        continueButton.disabled = !this.checked;

    });

    // Remember preference
    disableReminder.addEventListener("change", function () {

        if (this.checked) {

            localStorage.setItem(
                "disable-size-reminder",
                "true"
            );

        } else {

            localStorage.removeItem(
                "disable-size-reminder"
            );

        }

    });

    // Continue to Cart
    continueButton.addEventListener("click", function () {

        if (!confirmCheckbox.checked) return;

        popup.close();

        if (originalButton) {

            bypassReminder = true;

            // Wait until popup closes
            setTimeout(() => {

                originalButton.click();

            }, 100);

        }

    });

    // Reset popup when closed
    popup.addEventListener("close", function () {

        continueButton.disabled = true;
        confirmCheckbox.checked = false;

    });

});